import { Button, CharField, Flex, H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { useQsFilters } from "../../hooks/filters"
import { FiltersBase } from "../../types"
import { TableParatesti } from "./TableParatesti"
import { useParatestiList } from "../../hooks/paratesti"
import { useNavigate } from "react-router-dom"

const initFilters = (params: URLSearchParams) =>
  ({
    page: Number(params.get("page") ?? 1),
    search: params.get("search") ?? "",
    ordering: params.get("ordering") ?? "titolo",
  } as FiltersBase)

export default function Paratesti() {
  const { filters, uiFilters, setFilters } = useQsFilters(initFilters)

  const { data } = useParatestiList({
    page: String(filters.page),
    search: filters.search,
    ordering: filters.ordering,
  })

  useBreadcrumbs([{ label: "Paratesti" }])

  const navigate = useNavigate()

  return (
    <Layout>
      <Flex direction="column" justifyContent="start" alignItems="stretch" className="w-100 h-100">
        <Flex alignItems="center" justifyContent="between" className="mb-5">
          <H1>Paratesti</H1>
          <Button
            size="md"
            className="text-white"
            title="Aggiungi"
            leadingIcon="add"
            onClick={() => {
              navigate("/edizioni/paratesti/new")
            }}
          />
        </Flex>
        <Flex className="mb-3">
          <CharField
            label=""
            placeholder="Cerca..."
            leadingIcon="search"
            style={{
              width: 300,
            }}
            value={filters.search}
            onChange={(value) => {
              setFilters({ ...filters, search: value })
            }}
          />
        </Flex>
        <TableParatesti
          showEdizione
          paratesti={data?.results || []}
          setFilters={setFilters}
          filters={uiFilters}
          count={data?.count || 0}
          fullCount={data?.full_count || 0}
        />
      </Flex>
    </Layout>
  )
}
